import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { To, NavigateOptions } from 'react-router';
import { useBridge } from './useBridge';
import {
  IN_APP_LANDING_TYPE,
  LANDING_TYPE,
  MEDIA_NAME,
  PAGE_NM,
} from '../types/types';
import { getAppVersionNum } from '../helper/appUtils';
import { isIOS } from 'react-device-detect';

export const urlAddService: { [index: string]: any } = {
  [IN_APP_LANDING_TYPE.S_EB_HOME]: {
    type: 'EBMP',
    url:
      process.env.REACT_APP_EBMP_SKT_URI +
      '?extraParam=3&extraParam2=' +
      (process.env.REACT_APP_ENV === 'production' ? 'A007BA01' : 'A007BA02'),
  },
  [IN_APP_LANDING_TYPE.S_EB_LOAN]: {
    type: 'EBMP',
    url: '',
  },
  [IN_APP_LANDING_TYPE.K_EB_LOAN]: {
    type: 'EBMP',
    url: '',
  },
  [IN_APP_LANDING_TYPE.K_EB_HOME]: {
    type: 'EBMP',
    url: process.env.REACT_APP_EBMP_KT_URI + '?src_cd=D007BA01',
  },
  [IN_APP_LANDING_TYPE.K_MD_CS]: {
    type: 'MYDATA',
    url:
      process.env.REACT_APP_MYDATA_KT_URI +
      '?redirectUrl=%2Fmobile%2FassetMain.kt%26targetEvent%3DcreditScoreFocus',
  },
  [IN_APP_LANDING_TYPE.K_MD_CREDIT]: {
    type: 'CREDIT',
    url: '',
    noneMemberUrl: `${process.env.REACT_APP_CREDIT_KT_URI}/BAMKRTKCF90`, // 비회원
    freeMemberUrl: `${process.env.REACT_APP_CREDIT_KT_URI}/BAMKRTKCAM1`, // 무료회원
    paidMemberUrl: `${process.env.REACT_APP_CREDIT_KT_URI}/BAMKRTKCAM1`, // 유료회원
    needMoveAfterJoin: true,
  },
  [IN_APP_LANDING_TYPE.K_LB_CREDIT]: {
    type: 'CREDIT',
    url: '',
    noneMemberUrl: `${process.env.REACT_APP_CREDIT_KT_URI}/BAMKRTCDF10`,
    freeMemberUrl: `${process.env.REACT_APP_CREDIT_KT_URI}/BAMKRTCD000`,
    paidMemberUrl: `${process.env.REACT_APP_CREDIT_KT_URI}/BAMKRTKCAM1`,
    needMoveAfterJoin: false,
  },
  [IN_APP_LANDING_TYPE.K_MD_CB]: {
    type: 'MYDATA',
    url:
      process.env.REACT_APP_MYDATA_KT_URI +
      '?redirectUrl=%2Fmobile%2FassetMain.kt%26targetEvent%3DcreditScoreBooster',
  },
  [IN_APP_LANDING_TYPE.L_EB_HOME]: {
    type: 'EBMP',
    url: '?tabSeq=1&track_cd_type=B007BA01',
  },
  [IN_APP_LANDING_TYPE.L_EB_LOAN]: {
    type: 'EBMP',
    url: '?tabSeq=1&track_cd_type=B007BA01',
  },
};

const useNav = () => {
  const routerNavigate = useNavigate();
  const location: any = useLocation();
  const { media } = useParams();
  const br: any = useBridge();
  let query = location.search;

  // props 'to'에 매체 정보 없는 경우
  const navigate = (to: To, options?: NavigateOptions) => {
    let pathname =
      typeof to === 'string' ? `/${media}` + to : `/${media}` + to?.pathname;
    if (pathname.includes('?')) {
      const splitPath = pathname.split('?');
      pathname = splitPath[0];
      query = splitPath[1] && query + '&' + splitPath[1];
    }
    routerNavigate({ pathname, search: query }, options && options);
  };

  const navigateMain = () => {
    if (window.history.state.idx >= 1) {
      const back = -1 * window.history.state.idx;
      routerNavigate(back);
    } else {
      navigate(`/mtg/main`, { replace: true });
    }
  };

  const navigateHome = () => {
    if (window.history.state.idx >= 1) {
      const back = -1 * window.history.state.idx;
      routerNavigate(back);
    } else {
      navigate(`/main`, { replace: true });
    }
  };

  const navigateMtgMain = () => {
    if (window.history.state.idx >= 2) {
      const back = -1 * (window.history.state.idx - 1);
      routerNavigate(back);
    } else {
      navigate(`/mtg/mtgMain`, { replace: true });
    }
  };

  const navigateCreditMain = () => {};

  // props 'to'에 매체 정보가 포함되어있는 경우
  const redirectNavigate = (to: To, options?: NavigateOptions) => {
    routerNavigate(to + query, options && options);
  };

  // 뒤로가기 navigator
  const historyBack = () => {
    if (window.history.state.idx === 0) {
      br?.close();
      return;
    }

    const path = window.location.pathname;
    const pathRemovedMedia = path.replace(/^(\/skt)|(\/kt)|(\/lgu)/, '');
    if (pathRemovedMedia.includes('/mtg/conditions')) {
      const step = Number(path.slice(path.length - 1, path.length)) - 1;
      if (
        pathRemovedMedia === '/mtg/conditions/3' &&
        window.history.state?.usr?.ref_page === '/conditions/7'
      ) {
        routerNavigate(-1);
        return;
      } else if (step !== 0) {
        navigate(`/mtg/conditions/${step}`, { replace: true });
        return;
      } else if (window.history.state?.usr?.ref_page === '/mtg/result') {
        navigateMtgMain();
        return;
      }
    } else if (pathRemovedMedia === '/mtg/result-complete') {
      navigate(`/mtg/result`, { replace: true });
      return;
    } else if (pathRemovedMedia === '/mtg/result') {
      navigateMtgMain();
      return;
    } else if (
      pathRemovedMedia === '/conditions/2' &&
      location?.state?.ref_page === PAGE_NM.MTG_CONFIRM
    ) {
      navigate(`/mtg/conditions/7`, { replace: true });
      return;
    } else if (pathRemovedMedia === '/mtg/loading') {
      navigateMtgMain();
      return;
    }

    routerNavigate(-1);
  };

  const navigateByLinkType = (
    landingType: LANDING_TYPE,
    landingDestination: any,
  ) => {
    if (landingType === LANDING_TYPE.in_app) {
      switch (landingDestination) {
        case IN_APP_LANDING_TYPE.S_PA_HOME:
        case IN_APP_LANDING_TYPE.K_PA_HOME:
        case IN_APP_LANDING_TYPE.L_PA_HOME:
          br.goNativeMain();
          break;
        case IN_APP_LANDING_TYPE.S_EB_HOME:
        case IN_APP_LANDING_TYPE.S_EB_LOAN:

        case IN_APP_LANDING_TYPE.K_EB_HOME:
        case IN_APP_LANDING_TYPE.K_EB_LOAN:

        case IN_APP_LANDING_TYPE.L_EB_HOME:
        case IN_APP_LANDING_TYPE.L_EB_LOAN:

        case IN_APP_LANDING_TYPE.K_MD_CS:
        case IN_APP_LANDING_TYPE.K_MD_CB:
        case IN_APP_LANDING_TYPE.K_LB_CREDIT:
        case IN_APP_LANDING_TYPE.K_MD_CREDIT:
          br.requestAddService(urlAddService[landingDestination]);
          break;
      }
    } else if (landingType === LANDING_TYPE.out_link) {
      const url = landingDestination;
      br.openExternalBrowser({ url });
    } else if (landingType === LANDING_TYPE.in_link) {
      let path = landingDestination;

      if (
        landingDestination.indexOf('http://') === 0 ||
        landingDestination.indexOf('https://') === 0
      ) {
        const url = new URL(landingDestination);
        path = url.pathname;
      }

      redirectNavigate(path);
    }
  };

  const navigateMyDataCredit = () => {
    let landingDestination = '';
    if (media === MEDIA_NAME.SKT) {
      landingDestination = '';
    } else if (media === MEDIA_NAME.KT) {
      landingDestination = IN_APP_LANDING_TYPE.K_MD_CS;
    } else if (media === MEDIA_NAME.LGU) {
      landingDestination = '';
    }
    if (landingDestination)
      navigateByLinkType(LANDING_TYPE.in_app, landingDestination);
  };

  const canUseCredit = () => {
    if (media !== MEDIA_NAME.KT) return false;

    const appVersion = getAppVersionNum(media);
    const minVersion = isIOS ? 200010036 : 200010041;
    return appVersion >= minVersion;
  };

  const navigateCreditOrMyDataByAppversion = () => {
    let landingDestination = '';
    if (media === MEDIA_NAME.SKT) {
      landingDestination = '';
    } else if (media === MEDIA_NAME.KT) {
      if (canUseCredit()) {
        landingDestination = IN_APP_LANDING_TYPE.K_LB_CREDIT;
      } else {
        landingDestination = IN_APP_LANDING_TYPE.K_MD_CS;
      }
    } else if (media === MEDIA_NAME.LGU) {
      landingDestination = '';
    }
    if (landingDestination)
      navigateByLinkType(LANDING_TYPE.in_app, landingDestination);
  };

  return {
    routerNavigate,
    navigate,
    navigateHome,
    navigateMain,
    navigateMtgMain,
    navigateCreditMain,
    historyBack,
    redirectNavigate,
    navigateByLinkType,
    canUseCredit,
    navigateCreditOrMyDataByAppversion,
  };
};

export default useNav;
